<template>
  <v-form ref="listWeldingProcedureForm">
    <v-container>
      <v-row>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" class="pb-0">
          <div class="d-flex" v-if="filterBadge.length > 0">
            <v-chip small class="mr-2" v-for="(text, index) in filterBadge" :key="index">{{text}}</v-chip>
          </div>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="12" xs="12" :class="[$vuetify.breakpoint.mdAndDown ? 'text-left' : 'text-right']">
          <!-- <v-btn :to="'weldingProcedure/create'" class="primary" small>Add</v-btn> -->
          <v-btn v-if="$checkRight(['edit_welding_procedure'])" @click="formModal = true" class="primary" small>Add</v-btn>
          <v-btn @click="openDrawer = !openDrawer" class="ml-2" small color="#eee">
            <v-icon small>mdi-filter</v-icon>
          </v-btn>
          <v-btn @click="deactiveWeldingProcedure" class="ml-2" small color="#eee" v-if="$checkRight(['edit_welding_procedure'])">
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
          <v-btn @click="clearFilter(false);$refreshDataTable()" class="ml-2" small color="#eee">
            <v-icon small>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-dialog v-model="formModal" width="600">
        <v-card>
          <v-card-title class="headline">Select Form</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="text-center mt-5">
            <v-btn color="success" :to="'weldingProcedure/wpsAws/create'" class="ma-1">WPS-AWS</v-btn>
            <v-btn color="success" :to="'weldingProcedure/wpsAsme/create'" class="ma-1">WPS-ASME</v-btn>
            <v-btn color="success" :to="'weldingProcedure/pqrAws/create'" class="ma-1">PQR-AWS</v-btn>
            <v-btn color="success" :to="'weldingProcedure/pqrAsme/create'" class="ma-1">PQR-ASME</v-btn>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="formModal= false">close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- Datatable -->
      <datatable
        ref="weldingProcedure_datatable"
        :tableOption="tableOption"
        :tableItemSlot="tableItemSlot"
      />
      <!-- Filter -->
      <popup-drawer :value.sync="openDrawer" :openDrawer="openDrawer">
        <v-col cols="12">
          <v-text-field
            placeholder="Procedure No"
            label="Procedure No"
            v-model="filter.serial_no"
            autofocus
          ></v-text-field>
        </v-col>
        <v-col cols="12">
          <v-select
            clearable
            return-object
            item-value="id"
            label="Type"
            placeholder="Type"
            v-model="filter.type"
            :items="[{id: 'wps_aws', text: 'WPS-AWS'}, {id: 'wps_asme', text: 'WPS-ASME'}, {id: 'pqr_aws', text: 'PQR-AWS'}, {id: 'pqr_asme', text: 'PQR-ASME'}]">
          </v-select>
        </v-col>
        <v-col cols="12">
          <searchable-select ref="filterReferredStdId" :value.sync="filter.referred_standard_id" :options="{ url: 'referred_standard', label: 'Refrerred Standard', returnType: 'object'}"/>
        </v-col>
        <v-col cols="12">
          <searchable-select ref="filterQualificationMethodId" :value.sync="filter.qualification_method_id" :options="{ url: 'qualification_method', label: 'Qualification Method', returnType: 'object'}"/>
        </v-col>
        <v-col cols="12">
          <v-select
          clearable
          return-object
          item-value="id"
          label="Status"
          placeholder="Status"
          v-model="filter.status"
          :items="[{id: 0, text: 'Active', color: 'success'}, {id: 1, text: 'Inactive', color: 'warning'}]"
          :small-chips="true">
          <template #selection="{ item }">
            <v-chip :color="item.color" small>{{item.text}}</v-chip>
          </template>
        </v-select>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-btn @click="filterData" class="mt-4" color="primary" small>Filter</v-btn>
        <v-btn @click="clearFilter" class="mt-4 ml-2" small>Clear</v-btn>
      </v-col>
    </popup-drawer>
    </v-container>
  </v-form>
</template>
<script>
import datatable from '@/components/datatable.vue'
export default {
  components: {
    datatable
  },
  computed: {
    filterBadge () {
      const fList = []
      Object.keys(this.filterDisplay).map((x, i) => {
        if (typeof this.filterDisplay[x] === 'object') {
          fList.push(this.filterDisplay[x].text)
        } else if (this.filterDisplay[x]) {
          fList.push(this.filterDisplay[x])
        }
      })
      return fList
    }
  },
  created () {
    if (!this.$checkRight(['edit_welding_procedure'])) {
      this.tableOption.headers.shift()
    }
  },
  data () {
    return {
      loading: true,
      selected: [],
      dialog: false,
      formModal: false,
      tableOption: {
        url: 'getWeldingProcedureAll',
        // editUrl: 'weldingProcedure/edit',
        deleteRoute: 'deactiveWeldingProcedure',
        moduleName: 'weldingProcedure',
        headers: [
          { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 80 },
          { text: 'Procedure No', align: 'start', value: 'serial_no' },
          { text: 'Pqr', value: 'pqr_name' },
          { text: 'Referred Standard', value: 'referred_standard_name' },
          { text: 'Qualification Method', value: 'qualification_method_name' },
          { text: 'Status', value: 'status', align: 'center' },
        ]
      },
      tableItemSlot: {
        status: {
          0: { color: 'green', text: 'Active' },
          1: { color: 'orange', text: 'Inactive' }
        }
      },
      openDrawer: false,
      filter: {},
      filterDisplay: {}
    }
  },
  watch: {
    options: {
      handler () {
      },
      deep: true,
    },
  },
  mounted () {
  },
  methods: {
    deactiveWeldingProcedure () {
      this.$refs.weldingProcedure_datatable.massDeleteTableData()
    },
    filterData () {
      this.$eventBus.$emit('$filterDataTable', this.filter)
      this.openDrawer = false
      this.filterDisplay = this.filter ? JSON.parse(JSON.stringify(this.filter)) : {}
    },
    clearFilter (callEmit = true) {
      if (callEmit) {
        this.$eventBus.$emit('$filterDataTable', {})
      }
      this.openDrawer = false
      this.filter = {}
      this.filterDisplay = {}
      this.$refs.filterReferredStdId.selected = []
      this.$refs.filterQualificationMethodId.selected = []
    }
  },
}
</script>
<style lang="css">
.elevation-1 {
  table-layout: flex !important;
}
/* .v-data-table-header > tr > th:first-child{
  background: red;
} */
</style>
